import { FC } from 'react'
import rocketBase from '@/assets/images/rocket/rocket_base.svg'
import fire1 from '@/assets/images/rocket/fire_1.svg'
import fire2 from '@/assets/images/rocket/fire_2.svg'

import { Box, keyframes, styled } from '@mui/material'
import { theme } from '@/theme/theme'

type RocketPosition = 'left' | 'right' | 'center'
type RocketParams = {
  isFly?: boolean
  position?: RocketPosition
}
const floatAnimation = keyframes`
   0% { transform: translateY(0px) ; }
  50% { transform: translateY(-4px) rotate(1deg);; } 
  100% { transform: translateY(0px) ; }
`
const flameAnimation = keyframes`
   0% { transform: scale(1) ; }
  50% { transform:scale(1.1); } 
  100% { transform: scale(1) ; }
`

const Rocket: FC<RocketParams> = ({ isFly = true, position = 'left' }) => {
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      {isFly ? (
        <StyledFlyingRocketWrapper rocketPosition={position}>
          <StyledImgFire1 src={fire1} />
          <StyledImgFire2 src={fire2} />
          <StyledImgFlyingRocket src={rocketBase} alt="Rocket" />
        </StyledFlyingRocketWrapper>
      ) : (
        <StyledImgParkingRocket src={rocketBase} alt="Rocket" position={position} />
      )}
    </Box>
  )
}

const StyledImgFire1 = styled('img')(() => ({
  position: 'absolute',
  top: theme.spacing(3.2),
  left: theme.spacing(-4),
  animation: `${flameAnimation} 1s ease-in-out infinite`,
}))

const StyledImgFire2 = styled('img')(() => ({
  position: 'absolute',
  top: theme.spacing(3.5),
  left: theme.spacing(-3),
  animation: `${flameAnimation} 0.2s ease-in-out infinite`,
}))

const StyledImgFlyingRocket = styled('img')(() => ({
  position: 'absolute',
  transform: 'rotate(90deg)',
}))

const StyledImgParkingRocket = styled('img')(({ position }: { position: RocketPosition }) => ({
  position: 'absolute',
  top: theme.spacing(-1.5),
  right: position === 'right' ? 0 : position === 'center' ? '50%' : 'none',
}))

const StyledFlyingRocketWrapper = styled(Box)(({ rocketPosition }: { rocketPosition: RocketPosition }) => ({
  position: 'absolute',
  top: theme.spacing(-6.1),
  left: rocketPosition === 'left' ? theme.spacing(2) : 'none',
  right: rocketPosition === 'right' ? theme.spacing(6) : rocketPosition === 'center' ? '50%' : 'none',
  animation: `${floatAnimation} 3s ease-in-out infinite`,
  transform: 'rotate(90deg)',
}))
export default Rocket
